import React from "react";

export default function useForceUpdate() {
    const [value, setState] = React.useState(true);
    return () => setState(!value);
}
